import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Card, Empty, Skeleton, Tag, Typography } from 'antd';

import { useClickNewzz } from 'v2/hooks/useClickNewzz';
import { useListNewzz } from 'v2/hooks/useListNewzz';

const ITEMS_LIMIT = 8;

function News() {
  const { newzzList, isLoading } = useListNewzz(ITEMS_LIMIT);
  const { clickNewzz } = useClickNewzz();
  const isInitialLoading = isLoading && newzzList.length === 0;
  const isEmpty = !isLoading && newzzList.length === 0;

  return (
    <Card className='flex h-full min-h-107.5 flex-col' classNames={{ body: 'flex flex-1 flex-col' }} title='Newzz'>
      <div className='flex flex-1 flex-col'>
        {isInitialLoading ? (
          <div>
            {Array.from({ length: ITEMS_LIMIT }).map((_, index) => (
              <Skeleton key={`newzz-skeleton-${index}`} active paragraph={false} className='mb-3' />
            ))}
          </div>
        ) : isEmpty ? (
          <Empty description='Nenhuma novidade no momento.' />
        ) : (
          <ul className='m-0 list-none p-0'>
            {newzzList.map(item => {
              const titleNode = (
                <Typography.Text type='secondary' ellipsis={{ tooltip: item.title }} className='block min-w-0 flex-1'>
                  {item.title}
                </Typography.Text>
              );

              return (
                <li
                  key={item.id}
                  className='flex h-12 items-center gap-2 border-0 border-b border-solid border-(--uizz-antd-color-split)'
                >
                  {item.has_content ? (
                    <RouterLink
                      to={`news/info/${item.id}`}
                      onClick={() => clickNewzz(item.id)}
                      aria-label={`Abrir notícia: ${item.title}`}
                      className='flex min-w-0 flex-1 items-center no-underline'
                    >
                      {titleNode}
                    </RouterLink>
                  ) : (
                    <a
                      href={item.external_url}
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={() => clickNewzz(item.id)}
                      aria-label={`Abrir link externo: ${item.title}`}
                      className='flex min-w-0 flex-1 items-center no-underline'
                    >
                      {titleNode}
                    </a>
                  )}
                  {/* -me-2 cancela a margem inline-end padrão do Tag do antd */}
                  {item.show_tag_new ? <Tag className='-me-2 shrink-0'>NOVO</Tag> : null}
                </li>
              );
            })}
          </ul>
        )}

        {!isInitialLoading && newzzList.length > 0 && (
          <div className='mt-auto flex h-12 items-center'>
            <RouterLink to='/producer/news' aria-disabled={isLoading}>
              Ver mais novidades
            </RouterLink>
          </div>
        )}
      </div>
    </Card>
  );
}

export default News;
